import Image from './Image';

type Props = {
  alt: string;
  imageDesktop: string;
  imageMobile: string;
};

export default function SplashImage({ imageDesktop, imageMobile, alt }: Props) {
  return (
    <>
      <Image
        alt={alt}
        src={imageMobile}
        display="full-bleed"
        className="absolute block h-[406px] w-full object-cover object-right-bottom md:h-[506px]"
        loading="eager"
        responsiveOptions={{
          md: {
            src: imageDesktop
          },
          xs: {
            retainRatio: true,
            src: imageMobile
          }
        }}
        progressiveLoadSettings={{ highResQuality: 100, lowResQuality: 50 }}
      />
    </>
  );
}
